import { Observable } from 'rxjs';

import { UseCase }
from '../../base/use-case';

import { PerfilModel }
from '../../models/configuration/perfil.model';

import { ConfigurationRepository }
from '../../repositories/configuration.repository';

export class GetAllPerfilUseCase implements UseCase<void, PerfilModel> {

    constructor(
        private repository:
        ConfigurationRepository
    ) {}

    execute(
        
    ):
    Observable<PerfilModel> {

        return this.repository
            .getAllPerfil(
                
            );
    }
}